<template>
  <div>
    <v-dialog :value="show" @click:outside="closeDialog" scrollable max-width="500">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Seleccionar Grabacion
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text>
          <!-- Grabacion -->
          <v-col cols="12" class="pb-0">
            <v-text-field
              filled
              rounded
              label="Grabación"
              class="rounded-small"
              prepend-inner-icon="mdi-play"
              readonly
              :value="recordingSelected ? recordingSelected.fecha : ''"
              @click="showRecordingsDialog = true"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-select
              prepend-inner-icon="mdi-file"
              required
              filled
              rounded
              dense
              class="rounded-small"
              :items="Evaluations"
              item-text="name"
              label="Evaluacion"
              v-model="evaluationSelected"
              return-object
            ></v-select>
          </v-col>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="submitData"
            >
              Aceptar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <recordings-dialog
      v-if="showRecordingsDialog"
      :dateStart="dateStart"
      :dateEnd="dateEnd"
      :extension="extension"
      :recordingsDialog="showRecordingsDialog"
      @dialog:close="onSelectRecording"
    ></recordings-dialog>
  </div>
</template>

<script>
import RecordingsDialog from "../Tests/RecordingsDialog.vue";
export default {
  components: { RecordingsDialog },
  props: {
    show: {
      type: Boolean,
    },
    dateStart: {
      type: String,
    },
    dateEnd: {
      type: String,
    },
    extension: {
      type: String,
    },
  },
  data() {
    return {
      showRecordingsDialog: false,
      recordingSelected: null,
      recordingSelectedUrl: null,
      evaluationSelected: null,
    };
  },

  computed: {
    Evaluations() {
      return this.$store.getters["evaluations/GET_ALL_EVALUATIONS"];
    },
  },

  created() {
    this.getEvaluations();
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },

    submitData() {
      this.$emit("submit:data", {
        recordingSelected: this.recordingSelected,
        recordingSelectedUrl: this.recordingSelectedUrl,
        evaluationSelected: this.evaluationSelected.name,
      });
    },
    onSelectRecording({ item, url }) {
      if (item) {
        this.recordingSelected = item;
        this.recordingSelectedUrl = url;
      }
      this.showRecordingsDialog = false;
    },

    async getEvaluations() {
      try {
        await this.$store.dispatch("evaluations/SHOW_ALL_EVALUATIONS");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
